import React, { useState, useContext, FormEvent } from "react";
import { observer } from "mobx-react-lite";
import { Button, Form, Input, Select } from "semantic-ui-react";
import { IProjectScope } from "../../../app/models/projectscope";
import TransmissionStore from "../../../app/stores/transmissionStore";
const ProjectScopeEditForm: React.FC = () => {
  const transmissionStore = useContext(TransmissionStore);
  const { selectedProjectScope, editProjectScope, submitting, cancelFormOpen } =
    transmissionStore;

  const [projectScope, setProjectScope] = useState<IProjectScope>(
    selectedProjectScope!
  );

  const handleSubmit = () => {
    editProjectScope(projectScope);
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setProjectScope({ ...projectScope, [name]: value });
  };

  const type = [
    { key: "Scope", text: "Scope", value: "Scope" },
    { key: "Variation", text: "Variation", value: "Variation" },
  ];

  const status = [
    { key: "Not Started", text: "Not Started", value: "Not Started" },
    { key: "In Progress", text: "In Progress", value: "In Progress" },
    { key: "Completed", text: "Completed", value: "Completed" },
  ];

  return (
    <div>
      <Form onSubmit={handleSubmit}>
        <Form.Group>
          <Form.Field inline>
            <label>Description</label>
            <Input
              onChange={handleInputChange}
              name="description"
              value={projectScope.description}
            />
          </Form.Field>
          <Form.Field inline>
            <label>Type</label>
            <Select
              required
              onChange={(e, { name, value }) => {
                setProjectScope({ ...projectScope, [name]: value });
              }}
              options={type}
              search
              name="type"
              placeholder="Type"
              value={projectScope.type}
            />
          </Form.Field>
          <Form.Field inline>
            <label>Status</label>
            <Select
              required
              onChange={(e, { name, value }) => {
                setProjectScope({ ...projectScope, [name]: value });
              }}
              options={status}
              search
              name="status"
              placeholder="Status"
              value={projectScope.status}
            />
          </Form.Field>
          <Form.Field inline>
            <label>Remark</label>
            <Input
              onChange={handleInputChange}
              name="remark"
              value={projectScope.remark}
            />
          </Form.Field>
        </Form.Group>
        
          
            <Button
              loading={submitting}
              positive
              floated="right"
              type="submit"
              content="Submit"
            />
            <Button
              onClick={cancelFormOpen}
              floated="right"
              type="button"
              content="Cancel"
            />
        
      </Form>
    </div>
  );
};

export default observer(ProjectScopeEditForm);
